import "./assets/sass/theme.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import DashboardLayout from "./Layout/Dashboard.layout";
import MainLayout from "./Layout/Main.layout";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUser } from "./redux/actions/auth.action";

function App() {
  let dispatch = useDispatch();
  useEffect(() => {
    let authUser = JSON.parse(localStorage.getItem("auth"));
    if (authUser) {
      let { id } = authUser;
      console.log(id);
      dispatch(getUser(id));
    }
  });
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/main" render={(props) => <MainLayout {...props} />} />
          <Route
            path="/dashboard"
            render={(props) => <DashboardLayout {...props} />}
          />
          <Redirect to="/main" from="*" />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
